export const GENERAL_REPORT_ARCHETYPE_FETCH_SUCCESS = 'GENERAL_REPORT_ARCHETYPE_FETCH_SUCCESS';
export const GENERAL_REPORT_DATA_FETCH_SUCCESS = 'GENERAL_REPORT_DATA_FETCH_SUCCESS';
export const GENERAL_REPORT_DATA_FETCH_START = 'GENERAL_REPORT_DATA_FETCH_START';
export const GENERAL_REPORT_DATA_FETCH_FAILED = 'GENERAL_REPORT_DATA_FETCH_FAILED';
export const GENERAL_REPORT_DATA_CLEAR = 'GENERAL_REPORT_DATA_CLEAR';
export const GENERAL_REPORT_DATA_DOWNLOAD_PROGRESS_UPDATE = 'GENERAL_REPORT_DATA_DOWNLOAD_PROGRESS_UPDATE';
